import { render } from "./ProspectViewModal.vue?vue&type=template&id=fb23fd90&scoped=true"
import script from "./ProspectViewModal.vue?vue&type=script&lang=js"
export * from "./ProspectViewModal.vue?vue&type=script&lang=js"

import "./ProspectViewModal.vue?vue&type=style&index=0&id=fb23fd90&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb23fd90"]])

export default __exports__